import { Box, Grid, Paper, Tabs, Tab } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const RoomNav = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState("/rooms");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = ["/rooms", "/rooms/assigned-rooms-summary"];

    if (validPaths.includes(path)) {
      setValue(path);
    } else {
      setValue("/rooms");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" }, // Ensures tabs have consistent width
            }}
          >
            <Tab
              style={{
                ...tabStyle,
                backgroundColor: value === "/rooms" ? "#007174" : "white",
                color: value === "/rooms" ? "white" : "black",
              }}
              label={t("room.roomSummary")}
              value="/rooms"
              component={NavLink}
              to="/rooms"
            />

            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/rooms/assigned-rooms-summary"
                    ? "#007174"
                    : "white",
                color:
                  value === "/rooms/assigned-rooms-summary" ? "white" : "black",
              }}
              label={t("room.assignRoom")}
              value="/rooms/assigned-rooms-summary"
              component={NavLink}
              to="/rooms/assigned-rooms-summary"
            />
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default RoomNav;
